import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from 'rxjs/Observable';

import { DisabilityService } from '../../services/disability.service';
import { DisabilityCatService } from '../../services/disabilitycat.service';

@Component({
  templateUrl: "./disability.component.html",
  styleUrls: ["./disability.component.css"]
})
export class DisabilityComponent implements OnInit, OnDestroy {
  public disabilities: any[];
  public disabilityCategories: any[] = [];
  public disabilityForm: FormGroup;
  public disabilityId: string;
  public displayModal: boolean = false;
  public disabilityModalTitle: string;

  constructor(private disabilityService: DisabilityService,
    private disabilityCatService: DisabilityCatService,
    public fb: FormBuilder) { }

  ngOnInit() {
    Observable.forkJoin(this.disabilityCatService.getDisabilityCategories(),
      this.disabilityService.getDisabilities()).subscribe(
        ([categories, disabilities]) => {
          this.disabilityCategories = categories.body as any[];
          const disabilityData = disabilities.body as any[];
          // Category name must be injected into disability rows for the purpose of sorting display
          this.disabilities = disabilityData.map((item) => {
            const cat = this.disabilityCategories.find(c => c.DISABILITY_CATEGORY_ID === item.DISABILITY_CATEGORY_ID);
            item.categoryName = cat ? cat.DISABILITY_CATEGORY_NM : "No category found";
            return item;
          });
        }
      );
    this.disabilityForm = this.fb.group({
      disabilityName: ["", [Validators.required, Validators.pattern(/^[A-Za-z0-9_'\-\/\\().,=<>]+$/)]],
      disabilityDescription: ["", [Validators.required, Validators.pattern(/^[A-Za-z0-9_'\-\/\\().,=<>\s]+$/)]],
      disabilityInformation: ["", [Validators.required]],
      disabilityCategoryId: ["", [Validators.required]],
      disabilityStatus: ["", [Validators.required]],
      disabilityDisplayOrder: ["", [Validators.required, Validators.pattern(/^[0-9]+$/)]],
    });
  }

  onNew() {
    this.disabilityModalTitle = "Add Disability";
    this.disabilityForm.setValue({
      disabilityName: "",
      disabilityDescription: "",
      disabilityInformation: "",
      disabilityCategoryId: this.disabilityCategories[0].DISABILITY_CATEGORY_ID,
      disabilityStatus: "A",
      disabilityDisplayOrder: "",
    });
    this.disabilityForm.controls["disabilityName"].enable();
    this.disabilityForm.controls["disabilityCategoryId"].enable();
    this.displayModal = true;
  }

  onEdit(item) {
    this.disabilityModalTitle = "Edit Disability";
    this.disabilityId = item.DISABILITY_ID;
    this.disabilityForm.setValue({
      disabilityName: item.DISABILITY_NM,
      disabilityDescription: item.DISABILITY_DS,
      disabilityInformation: item.INFORMATION_TX,
      disabilityCategoryId: item.DISABILITY_CATEGORY_ID,
      disabilityStatus: item.STATUS_CD,
      disabilityDisplayOrder: item.DISPLAY_ORDER_NO
    });
    this.disabilityForm.controls["disabilityName"].disable();
    this.disabilityForm.controls["disabilityCategoryId"].disable();
    this.displayModal = true;
  }

  onSave() {
    if (this.disabilityId) {
      const updatedDisability = {
        DISABILITY_DS: this.disabilityForm.value.disabilityDescription,
        INFORMATION_TX: this.disabilityForm.value.disabilityInformation,
        STATUS_CD: this.disabilityForm.value.disabilityStatus,
        DISPLAY_ORDER_NO: this.disabilityForm.value.disabilityDisplayOrder
      };
      this.disabilityService.updateDisability(this.disabilityId, updatedDisability).subscribe(resp => {
        if (resp) {
          this.onClose();
          this.ngOnInit();
        }
      });
    } else {
      const newDisability = {
        DISABILITY_NM: this.disabilityForm.value.disabilityName,
        DISABILITY_DS: this.disabilityForm.value.disabilityDescription,
        INFORMATION_TX: this.disabilityForm.value.disabilityInformation,
        DISABILITY_CATEGORY_ID: this.disabilityForm.value.disabilityCategoryId,
        STATUS_CD: this.disabilityForm.value.disabilityStatus,
        DISPLAY_ORDER_NO: this.disabilityForm.value.disabilityDisplayOrder
      };
      this.disabilityService.createDisability(newDisability).subscribe(resp => {
        if (resp) {
          this.onClose();
          this.ngOnInit();
        }
      });
    }
  }

  onClose() {
    this.disabilityId = null;
    this.displayModal = false;
    this.disabilityForm.reset();
  }

  codeDisplay(code: string) {
    switch (code) {
      case "A": return "Active";
      case "I": return "Inactive";
      default: return "None";
    }
  }

  required(name: string) {
    const ctrl = this.disabilityForm.get(name);
    return this.controlInvalid(ctrl) && ctrl.errors.required;
  }

  valid(name: string) {
    const ctrl = this.disabilityForm.get(name);
    return this.controlInvalid(ctrl) && ctrl.errors.pattern;
  }

  controlInvalid(ctrl: AbstractControl) {
    return ctrl.invalid && (ctrl.dirty || ctrl.touched);
  }

  formInvalid() {
    return this.disabilityForm.status === "INVALID";
  }

  ngOnDestroy() { }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/Disability/disability.component.ts